import type { Discount, InterestRateApiPackage } from '@/models';
import { DiscountType, SustainabilityDiscount } from '@/constants';
import type { InterestRatesApiResponse } from '@shared/models';
import { MortgageTypeIrt } from '@shared/constants';
import { standardHttpService } from '@/services/HttpService';

export const RATES_URL = '/mortgage-customer-interest-rate-calculation/v1/interest-rates/calculate';

function getDiscounts(isBankDiscount: boolean, isSustainabilityDiscount: boolean, sustainabilityDiscount: SustainabilityDiscount): ReadonlyArray<Discount> {
  let discounts: ReadonlyArray<Discount> = [];
  if (isBankDiscount) discounts = [...discounts, { type: DiscountType.BankAccount }];
  if (isSustainabilityDiscount) discounts = [...discounts, { type: DiscountType.Sustainability, label: sustainabilityDiscount }];
  return discounts;
}

export function getInterestRates(
  product: string,
  type: string,
  isBankDiscount: boolean,
  isSustainabilityDiscount: boolean,
  sustainabilityDiscount: SustainabilityDiscount
): Promise<{ readonly data: InterestRatesApiResponse }> {
  const { credit } = MortgageTypeIrt;

  let body: Partial<InterestRateApiPackage> = {
    product: product.toUpperCase(),
    type: type.toUpperCase()
  };

  const discounts = getDiscounts(isBankDiscount, isSustainabilityDiscount, sustainabilityDiscount);
  if (discounts.length > 0 && type !== credit) {
    body = { ...body, discounts };
  }

  return standardHttpService.post(RATES_URL, body, { params: { inactive: true } });
}
